import { createBrowserRouter, createRoutesFromElements, Route } from 'react-router-dom';

import App from 'components/App';
import Auth from 'components/Pages/Auth';
import Call from 'components/Pages/Call';
import DevicePermissionDenied from 'components/Pages/DevicePermissionDenied';
import Exit from 'components/Pages/Exit';
import Preparation from 'components/Pages/Preparation';
import Record from 'components/Pages/Record';
import UnavailableContent from 'components/Pages/UnavailableContent';

import { EPaths } from './const/paths';

export const router = createBrowserRouter(
    createRoutesFromElements(
        <Route path={EPaths.ROOT} element={<App />}>
            <Route path={EPaths.CALL} element={<Call />} />
            <Route path={EPaths.RECORD} element={<Record />} />
            <Route path={EPaths.UNAVAILABLE_CONTENT} element={<UnavailableContent />} />
            <Route path={EPaths.AUTH} element={<Auth />} />
            <Route path={EPaths.EXIT} element={<Exit />} />
            <Route path={EPaths.DEVICE_PERMISSION_DENIED} element={<DevicePermissionDenied />} />
            <Route path={EPaths.PREPARATION} element={<Preparation />} />
        </Route>,
    ),
);
